import React from "react";

const AddIconRound = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.21053 14.7891H10.7895V10.6378H15V9.08104H10.7895V4.92971H9.21053V9.08104H5V10.6378H9.21053V14.7891ZM10.0018 19.7188C8.61868 19.7188 7.3186 19.4601 6.10158 18.9425C4.88456 18.425 3.82596 17.7226 2.92579 16.8355C2.02561 15.9483 1.31289 14.905 0.787631 13.7056C0.262544 12.5062 0 11.2248 0 9.86123C0 8.49752 0.262456 7.21571 0.787368 6.0158C1.31228 4.81589 2.02465 3.77218 2.92447 2.88466C3.8243 1.99714 4.88246 1.29444 6.09895 0.776558C7.31544 0.258853 8.61518 0 9.99816 0C11.3813 0 12.6814 0.258766 13.8984 0.776299C15.1154 1.29383 16.174 1.99619 17.0742 2.88336C17.9744 3.77053 18.6871 4.81382 19.2124 6.01321C19.7375 7.21259 20 8.49406 20 9.8576C20 11.2213 19.7375 12.5031 19.2126 13.703C18.6877 14.9029 17.9754 15.9467 17.0755 16.8342C16.1757 17.7217 15.1175 18.4244 13.9011 18.9423C12.6846 19.46 11.3848 19.7188 10.0018 19.7188ZM10 18.1621C12.3509 18.1621 14.3421 17.3578 15.9737 15.7491C17.6053 14.1405 18.4211 12.1772 18.4211 9.85941C18.4211 7.54159 17.6053 5.57835 15.9737 3.96971C14.3421 2.36107 12.3509 1.55675 10 1.55675C7.64912 1.55675 5.6579 2.36107 4.02632 3.96971C2.39474 5.57835 1.57895 7.54159 1.57895 9.85941C1.57895 12.1772 2.39474 14.1405 4.02632 15.7491C5.6579 17.3578 7.64912 18.1621 10 18.1621Z"
        fill="#2F80ED"
      />
    </svg>
  );
};

export default AddIconRound;
